import React from 'react'
import { connect } from 'react-redux'
import { logoff } from '../ducks/Auth'
import * as Ps from 'perfect-scrollbar'
import { resetForm, submitForm } from '../ducks/Forms'
import 'perfect-scrollbar/dist/css/perfect-scrollbar.min.css'
import PartnerSidebar from 'components/Sidebar/PartnerSidebar.jsx'
import PartnerHeader from 'components/Header/PartnerHeader.jsx'
import { Switch, Route, Redirect, withRouter } from 'react-router-dom'

import partnerRoutes from '../routes/partner.jsx'

class Partner extends React.Component {

    isMac() {
        let bool = false
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true
        }
        return bool
    }
    componentDidUpdate(e) {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            setTimeout(() => { Ps.update(this.refs.mainPanel) }, 350)
        }
        if (e.history.action === "PUSH") {
            this.refs.mainPanel.scrollTop = 0
        }
    }

    render() {
        const { user, resetForm, submitForm } = this.props
        
        return (
            <div className="wrapper">
                <PartnerSidebar {...this.props} />
                <div className="main-panel" ref="mainPanel">
                    <PartnerHeader {...this.props} />
                    <Switch>
                        {
                            partnerRoutes.map((route, key) => {
                                return <Route
                                    path={route.path}
                                    render={() => <route.component user={user} resetForm={resetForm} submitForm={submitForm} />}
                                    key={key}
                                />
                            })
                        }
                        <Route render={() => <Redirect to="/partner/dashboard" />} />
                    </Switch>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ user: state.auth.user })

export default withRouter(connect(mapStateToProps, { logoff, resetForm, submitForm })(Partner))




// WEBPACK FOOTER //
// ./src/containers/Partner.jsx